import { NetPriceSourceEnum } from 'libs/enums';
import { findEnumLabel, SectionRow, templatePriceConfigQuoteMode } from './AgreementContent';
import QuestionIcon from './QuestionIcon';
import SimpleTable from './SimpleTable';

const priceRuleList = [
  { label: '按价格波动比例调价', value: 1 },
  { label: '按价格波动区间调价', value: 2 },
];

export default function AgreementRenovationPrice({
  previewObj,
  tradeModePriceRenderInstructConcrete,
  onClickTableTip,
  showToast,
  hasAccountPeriod,
}: {
  previewObj: any;
  tradeModePriceRenderInstructConcrete: any;
  onClickTableTip: (tip: string) => void;
  showToast: (message: string) => void;
  hasAccountPeriod: (index) => boolean;
}) {
  const isShangHaiYouSe =
    previewObj.config.renovationConfig?.netPriceSourceEnum === NetPriceSourceEnum.SHYSJSW;
  const isGangTieWang =
    previewObj.config.renovationConfig?.netPriceSourceEnum === NetPriceSourceEnum.WDGTW;
  const baseNetPrice2RenderInstruct = [
    {
      key: 'indexName',
      label: '品种',
      width: '200px',
      renderFn(data) {
        return data.indexName;
      },
    },
    {
      key: 'price',
      label: '含税基准价(元)',
      width: '200px',
      renderFn(data) {
        return data.price;
      },
    },
  ];
  const baseNetPrice1RenderInstruct = [
    {
      key: 'areaName',
      label: '地区',
      width: '100px',
      renderFn: function (data) {
        return data.areaName;
      },
    },
    {
      key: 'brandName',
      label: '钢厂',
      width: '100px',
      renderFn: function (data) {
        return data.brandName;
      },
    },
    {
      key: 'breedName',
      label: '品种',
      width: '100px',
      renderFn: function (data) {
        return data.breedName;
      },
    },
    {
      key: 'materialQuantityName',
      label: '材质',
      width: '100px',
      renderFn: function (data) {
        return data.materialQuantityName;
      },
    },
    {
      key: 'modelName',
      label: '规格',
      width: '100px',
      renderFn: function (data) {
        return data.modelName;
      },
    },
    isGangTieWang
      ? {
          key: 'indexTypeName',
          label: '价格类型',
          width: '100px',
          renderFn: function (data) {
            return data.indexTypeName;
          },
        }
      : null,
    {
      key: 'price',
      label: '含税基准价(元)',
      width: '100px',
      renderFn: function (data) {
        return data.price;
      },
    },
  ].filter(Boolean);

  const rateConfigRenderInstruct = [
    {
      key: 'rate',
      label: '条件',
      width: '200px',
      renderFn: function (data, index) {
        if (index === 0) {
          return '价格波动± ' + data.rate + '%';
        } else if (index === 1) {
          return '涨幅超过' + data.rate + '%';
        } else if (index === 2) {
          return '跌幅超过' + data.rate + '%';
        } else if (index === 3) {
          return '涨幅超过' + data.rate + '%';
        } else if (index === 4) {
          return '跌幅超过' + data.rate + '%';
        }
      },
    },
    {
      key: 'formula',
      label: '公式选择',
      width: '200px',
      renderFn: function (data, index) {
        if (index === 0) {
          return '不调价';
        } else {
          return data.formula;
        }
      },
    },
    {
      key: 'formulaString',
      label: '单价计价公式',
      width: '200px',
      renderFn: function (data, index) {
        if (index === 0) {
          return '不调价';
        } else {
          return data.formulaString;
        }
      },
    },
  ];

  const range1ConfigRenderInstruct = [
    {
      key: 'formula',
      label: '公式选择',
      width: '200px',
      renderFn: function (data) {
        return data.formula;
      },
    },
    {
      key: 'formulaString',
      label: '单价计价公式',
      width: '200px',
      renderFn: function (data) {
        return data.formulaString;
      },
    },
  ];

  const range2ConfigRenderInstruct = [
    {
      key: 'areaName',
      label: '条件',
      width: '200px',
      renderFn: function (data, index) {
        const { upperLimit, lowerLimit } = data;
        const name = previewObj.config.renovationConfig.baseNetPrice2.indexName + '（含税）';
        if (index === 0) {
          return `${upperLimit}元≥${name}≥${lowerLimit}元`;
        } else if (index === 1) {
          return `${name}≥${lowerLimit}元`;
        } else if (
          index ===
          previewObj.config.renovationConfig.rangeConfig.configList?.length - 1
        ) {
          return `${name}<${upperLimit}元`;
        } else {
          return `${upperLimit}元>${name}≥${lowerLimit}元`;
        }
      },
    },
    {
      key: 'xn',
      label: 'Xn取值',
      width: '200px',
      renderFn: function (data, index) {
        if (index === 0) {
          return '不调价';
        } else {
          return data.xn == null ? '用户自行填写价格' : 'Xn=' + data.xn + '%';
        }
      },
    },
  ];

  const wireCableRangeConfigRenderInstruct = [
    {
      key: 'rate',
      label: '条件',
      width: '200px',
      renderFn: function (data, index) {
        if (index === 0) {
          return '|B-C|≤' + data.upperLimit + '时';
        } else {
          return (
            '|B-C|>' +
            previewObj.config.renovationConfig.wireCableRangeConfig?.configList?.[0]?.upperLimit +
            '时'
          );
        }
      },
    },
    {
      key: 'formulaString',
      label: '公式选择',
      width: '400px',
      renderFn: function (data, index) {
        if (index === 0) {
          return '不调价';
        } else {
          return previewObj.config.renovationConfig.wireCableRangeConfig?.formulaString;
        }
      },
    },
    {
      key: 'y',
      label: '单价计价公式',
      width: '400px',
      renderFn: function (data, index) {
        if (index === 0) {
          return '不调价';
        } else {
          return previewObj.config.renovationConfig.wireCableRangeConfig?.formulaString?.replace(
            'y',
            data.y,
          );
        }
      },
    },
  ];

  function objectToArr(obj) {
    if (obj == null) {
      return [];
    } else {
      return [obj];
    }
  }

  return (
    <>
      <SectionRow title="报价类型:">
        <div>
          {findEnumLabel(
            templatePriceConfigQuoteMode,
            previewObj.config.renovationConfig.quoteModeEnum,
          )}
          <QuestionIcon
            onClick={() => {
              showToast(
                previewObj.config.renovationConfig.quoteModeEnum === 2
                  ? '含税单计价\n综合单价 = 含税单价\n小计 = 综合单价 * 数量'
                  : '除税价计价\n综合单价 = 除税单价 *（1 + 税率）\n小计 = 除税单价*（1 + 税率） * 数量',
              );
            }}
            title={(previewObj.config.renovationConfig.quoteModeEnum === 2
              ? '含税单计价\n综合单价 = 含税单价\n小计 = 综合单价 * 数量'
              : '除税价计价\n综合单价 = 除税单价 *（1 + 税率）\n小计 = 除税单价*（1 + 税率） * 数量'
            )
              .split('\n')
              .map((t, i) => (
                <div key={i}>{t}</div>
              ))}
          />
          ，商品开票税率为
          {previewObj.config.renovationConfig.taxRate}%
        </div>
      </SectionRow>
      <SectionRow title="网价来源:">
        <div>{previewObj.config.renovationConfig.netPriceSource}</div>
      </SectionRow>
      {isShangHaiYouSe && (
        <SectionRow title="是否是电线电缆计价模板(2026年新集采):" titleWidth="250px">
          <div>{previewObj.config.renovationConfig.isWireCableTemplate ? '是' : '否'}</div>
        </SectionRow>
      )}
      <SectionRow title="基准规格及含税基准价C:" bordered layout="vertical">
        {!isShangHaiYouSe && <p>地区不选择，则取下单时收货地址所在区域的网价</p>}
        {isShangHaiYouSe ? (
          <SimpleTable
            header={
              <div className="base-net-price2-header-wrap">
                <div className="base-net-price2-header-col">基准材料规格型号</div>
                <div className="base-net-price2-header-col">含税基准价C</div>
              </div>
            }
            tabledata={objectToArr(previewObj.config.renovationConfig.baseNetPrice2)}
            renderinstruction={baseNetPrice2RenderInstruct}
          />
        ) : (
          <SimpleTable
            tabledata={objectToArr(previewObj.config.renovationConfig.baseNetPrice1)}
            header={
              <div className="base-net-price2-header-wrap">
                <div className="base-net-price2-header-col base-net-price2-header-col-long">
                  基准材料规格型号
                </div>
                <div className="base-net-price2-header-col">含税基准价C</div>
              </div>
            }
            width={isGangTieWang ? '700px' : '600px'}
            renderinstruction={baseNetPrice1RenderInstruct}
          />
        )}
      </SectionRow>
      <SectionRow title="计价规则:" layout="vertical">
        <p>{previewObj.config.renovationConfig.priceRule}</p>
        {previewObj.config.renovationConfig.isWireCableTemplate ? (
          <div className="price-rule-list-wrap">
            {previewObj.config.renovationConfig.quoteModeEnum ===
            templatePriceConfigQuoteMode[0].value ? (
              <>
                <div>A指的是商品含税协议价/（1+税率），单位为元/m</div>
                <div>D指的是电缆铜含量，单位为t/m，y为单位换算调节系数</div>
                <div>B指的实时市场价/（1+税率），单位为元/t</div>
                <div>C指的是含税基准价/（1+税率），单位为元/t</div>
              </>
            ) : (
              <>
                <div>A指的是商品含税协议价，单位为元/m</div>
                <div>D指的是电缆铜含量，单位为t/m，y为单位换算调节系数</div>
                <div>B指的实时市场价，单位为元/t</div>
                <div>C指的是含税基准价，单位为元/t</div>
              </>
            )}
          </div>
        ) : (
          <div className="price-rule-list-wrap">
            {previewObj.config.renovationConfig.quoteModeEnum ===
            templatePriceConfigQuoteMode[0].value ? (
              <>
                <div>A指的是供应商不含税报价</div>
                <div>B指的是基准规格的实时市场价/（1+税率）</div>
                <div>C指的是基准规格设定的含税基准价/（1+税率）</div>
              </>
            ) : (
              <>
                <div>A指的是供应商含税报价</div>
                <div>B指的是基准规格的实时市场价</div>
                <div>C指的是基准规格设定的含税基准价</div>
              </>
            )}
          </div>
        )}
        {previewObj.config.renovationConfig.isWireCableTemplate ? (
          <SimpleTable
            tabledata={previewObj.config.renovationConfig.wireCableRangeConfig?.configList || []}
            renderinstruction={wireCableRangeConfigRenderInstruct}
          />
        ) : previewObj.config.renovationConfig.priceRuleEnum === priceRuleList[0].value ? (
          <SimpleTable
            tabledata={previewObj.config.renovationConfig.rateConfig.configList || []}
            renderinstruction={rateConfigRenderInstruct}
          />
        ) : (
          <>
            <SimpleTable
              tabledata={objectToArr(previewObj.config.renovationConfig.rangeConfig)}
              renderinstruction={range1ConfigRenderInstruct}
            />
            <div className="table-wrap">
              <SimpleTable
                tabledata={previewObj.config.renovationConfig.rangeConfig.configList || []}
                renderinstruction={range2ConfigRenderInstruct}
              />
            </div>
          </>
        )}
      </SectionRow>
      <SectionRow title="市场价取价规则:" layout="vertical">
        <div>
          <div className="price-row">(1) 以哪个环节的日期取市场价</div>
          <div>
            {hasAccountPeriod(1) && (
              <div>
                • 货到付款方式，取
                <span>
                  {previewObj.config.renovationConfig.takePriceRule.afterPaymentNetPriceDate}
                </span>
                网价
              </div>
            )}
            {hasAccountPeriod(3) && (
              <div>
                • 结算付款方式，取
                <span>{previewObj.config.renovationConfig.takePriceRule.customNetPriceDate}</span>
                网价
              </div>
            )}
            {hasAccountPeriod(0) && (
              <div>
                • 先款后货方式，取
                <span>
                  {previewObj.config.renovationConfig.takePriceRule.beforePaymentNetPriceDate}
                </span>
                网价
              </div>
            )}
            {hasAccountPeriod(2) && (
              <div>
                • 预付款方式，取
                <span>
                  {previewObj.config.renovationConfig.takePriceRule.prePaymentNetPriceDate}
                </span>
                网价
              </div>
            )}
          </div>
          {isShangHaiYouSe ? null : (
            <>
              <div className="price-row">
                (2) 取当天哪一条网价
                <QuestionIcon
                  onClick={() => {
                    showToast('均以当天提交单据时已发布的网价进行计算');
                  }}
                  title="均以当天提交单据时已发布的网价进行计算"
                />
              </div>
              <div>{previewObj.config.renovationConfig.takePriceRule.priceSelect || '--'}</div>
              <div>当天取价时暂未发布网价规则，取前1个工作日的网价</div>
            </>
          )}

          <div className="price-row">({isShangHaiYouSe ? 2 : 3}) 当天取价时暂未发布网价规则</div>
          <div>• 取前1个工作日的网价</div>
          <div className="price-row">({isShangHaiYouSe ? 3 : 4}) 节假日，周末取价规则</div>
          <div>• 周末取周五的网价，节假日取放假前一天网价，如遇到周末，顺延至周五</div>
          <div className="price-row">
            ({isShangHaiYouSe ? 4 : 5}) 不满足上述情况，采购方手动输入单价
          </div>
        </div>
      </SectionRow>
      {previewObj.config.renovationConfig.discountByMethods && (
        <SectionRow title="按交易方式浮动调价" layout="vertical">
          <SimpleTable
            tabledata={previewObj.config.renovationConfig.discountByMethodList}
            renderinstruction={tradeModePriceRenderInstructConcrete}
            onClickTip={onClickTableTip}
          />
        </SectionRow>
      )}
      <style jsx>{`
        .price-rule-list-wrap {
          margin-bottom: 15px;
        }
        .table-wrap {
          margin-top: 15px;
        }
        .base-net-price2-header-wrap {
          display: flex;
          align-items: center;
          border: 1px solid #eeeeee;
          border-bottom: none;
        }
        .base-net-price2-header-col {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 38px;
          padding: 5px;
          justify-content: start;
          align-items: center;
          font-size: 12px;
          color: #333333;
          font-weight: bold;
          min-width: 100px;
          background-color: #f6f6f6;
          flex: 1;
        }
        .base-net-price2-header-col.base-net-price2-header-col-long {
          min-width: 500px;
          justify-content: center;
        }
      `}</style>
    </>
  );
}
